/** The same person keeps the same color in the tray, suggestions and directory. */
const COLORS = [
  "var(--color-info, #0077C4)",
  "var(--signal-green, #00B877)",
  "var(--property-violet, #8055B5)",
  "var(--property-due-soon, #C56824)",
  "var(--property-rose, #BC5475)",
] as const;

/** "John Pike +1" (a punch with more assignees) is still John Pike's face. */
const withoutAdditionalCount = (name: string) => name.replace(/\s+\+\d+\s*$/, "");

export function assigneeAvatarColor(name: string): string {
  let hash = 0;
  for (const char of withoutAdditionalCount(name).trim().toLowerCase().replace(/\s+/g, " ")) {
    hash = (Math.imul(hash, 31) + char.charCodeAt(0)) >>> 0;
  }
  return COLORS[hash % COLORS.length]!;
}

export function assigneeInitials(name: string): string {
  const parts = withoutAdditionalCount(name).trim().split(/\s+/).filter(Boolean);
  return parts.length > 1 ? (parts[0]![0] + parts.at(-1)![0]).toUpperCase() : parts[0]?.slice(0, 2).toUpperCase() || "?";
}

export function AssigneeAvatar({ name, size = 24, ring = false }: { name: string; size?: number; ring?: boolean }) {
  const color = assigneeAvatarColor(name);
  return <span aria-hidden="true" data-assignee-avatar={name} style={{
    width: size, height: size, borderRadius: "50%", flex: "none",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    background: `color-mix(in srgb, ${color} 17%, var(--card, white))`,
    color, fontFamily: '"Inter", -apple-system, system-ui, sans-serif',
    fontWeight: 700, fontSize: size * .37, letterSpacing: 0,
    boxShadow: ring ? `0 0 0 2px ${color}` : undefined,
  }}>{assigneeInitials(name)}</span>;
}

/** `ring` matches the surface the stack sits on, so the faces read as cut-outs. */
export function AssigneeAvatarStack({ names, ring = "var(--card)" }: { names: string[]; ring?: string }) {
  const shown = names.slice(0, 3);
  return <span data-assignee-candidates style={{ display: "inline-flex", alignItems: "center", flex: "none", paddingRight: 2 }}>
    {shown.map((name, i) => <span key={`${name}:${i}`} style={{ display: "inline-flex", marginLeft: i ? -6 : 0, border: `2px solid ${ring}`, borderRadius: "50%" }}>
      <AssigneeAvatar name={name} size={20} />
    </span>)}
    {names.length > 3 && <span style={{ marginLeft: 2, fontSize: 10, color: "var(--muted-foreground)" }}>+{names.length - 3}</span>}
  </span>;
}
